import {Injectable} from '@angular/core';
import {AbstractResourceService, JsonApiResource} from "@irian-ro/abstract-resource";
import { HttpClient } from "@angular/common/http";
import { EnvironmentService } from '@irian-ro/util-environment';
import {WorkflowConfigDtoModel} from "@well/iriro-frontend-libs/workflows/domain";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class WorkflowConfigResourceService extends AbstractResourceService<WorkflowConfigDtoModel, WorkflowConfigDtoModel, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('workflowConfigUrl'),
      <any>null,
      WorkflowConfigDtoModel,
      <any>null,
      <any>null
    )
  }

  getTemplateByUuid(uuid: string) {
    return this.findOne(`template/${uuid}`)
  }

  getAllConfigs(): Observable<JsonApiResource<WorkflowConfigDtoModel[], any>> {
    return this.httpClient?.get(`${this.url}/all`, {headers: this.headers}).pipe(this.mapToListOfObjects());
  }
}
